import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import PVOffering from "@/pages/PVOffering";

export const Route = createFileRoute("/es/servicios/pharmacovigilance/control-bibliografico")({
  head: () => buildRouteHead("/es/servicios/pharmacovigilance/control-bibliografico"),
  component: PVOffering,
});

